const CHUNK_RELOAD_KEY = 'async_chunk_reload';
const CHUNK_RELOAD_PARAM = '_chunk';
const MAX_RELOAD_ATTEMPTS = 2;

export const isChunkLoadError = (error) =>
  !!error &&
  (error.name === 'ChunkLoadError' ||
    /Loading chunk [\d]+ failed/.test(error.message || '') ||
    /Unexpected token '<'/.test(error.message || ''));

const getAttempts = () => Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || '0') || 0;

/**
 * After a deploy, open tabs still reference old hashed chunks. Force a document
 * navigation (not location.reload) so proxies/browsers cannot reuse a cached
 * index.html that still points at deleted chunk hashes.
 */
export const reloadOnChunkError = (error) => {
  if (!isChunkLoadError(error)) {
    return false;
  }

  const attempts = getAttempts();
  if (attempts >= MAX_RELOAD_ATTEMPTS) {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    return false;
  }

  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(attempts + 1));

  const url = new URL(window.location.href);
  url.searchParams.set(CHUNK_RELOAD_PARAM, String(Date.now()));
  window.location.replace(url.toString());
  return true;
};

export const clearChunkReloadFlag = () => {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
};

/** Drop the cache-bust query after a successful load so routes stay clean. */
export const stripChunkReloadParam = () => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has(CHUNK_RELOAD_PARAM)) {
    return;
  }

  url.searchParams.delete(CHUNK_RELOAD_PARAM);
  const next = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState(null, '', next);
};

export const installChunkLoadErrorHandler = () => {
  stripChunkReloadParam();

  window.addEventListener('unhandledrejection', (event) => {
    if (reloadOnChunkError(event.reason)) {
      event.preventDefault();
    }
  });
};
